import { darken, lighten } from '@theme-ui/color'
import { ThemeUIStyleObject } from 'theme-ui'

const defaultHeader: ThemeUIStyleObject = {
  borderTopLeftRadius: 's',
  borderTopRightRadius: 's',
  color: 'white',
}

const defaultContent: ThemeUIStyleObject = {
  border: '2px solid',
  borderColor: 'primary',
  borderBottomLeftRadius: 's',
  borderBottomRightRadius: 's',
  px: 40,
  py: 20,
}

const panel = {
  header: {
    primary: {
      ...defaultHeader,
      bg: 'primary',
    },
    secondary: {
      ...defaultHeader,
      bg: lighten('primary', 0.4),
      color: darken('primary', 0.25),
    },
    error: {
      ...defaultHeader,
      bg: lighten('error', 0.2),
    },
  },
  content: {
    primary: {
      ...defaultContent,
    },
    secondary: {
      ...defaultContent,
      borderColor: lighten('primary', 0.4),
    },
    error: {
      ...defaultContent,
      borderColor: lighten('error', 0.2),
    },
  },
}

export default panel
